export const PACKAGE_TYPES_MAP = {
    GOLD: "GOLD",
    SILVER: "SILVER"
};

export const PACKAGE_TYPES_MAP_V2 = {
    SELL_PRO: "SELL_PRO",
    SELL_LITE: "SELL_LITE",
    FREE: "FREE"
};

export const PACKAGE_TYPES = Object.values(PACKAGE_TYPES_MAP);

export const PACKAGE_TYPES_V2 = Object.values(PACKAGE_TYPES_MAP_V2);

export const SELLER_PACKAGE_ORDER_STATUS = {
    PAYMENT_SUCCESS: "PAYMENT_SUCCESS",
    REFUNDED: "REFUNDED",
    FULFILLED: "FULFILLED",
    PARTIALLY_FULFILLED: "PARTIALLY_FULFILLED"
};

export const SELLER_PACKAGE_ORDER_STATUS_MAPPING = {
    [SELLER_PACKAGE_ORDER_STATUS.PAYMENT_SUCCESS]: "Payment successful",
    [SELLER_PACKAGE_ORDER_STATUS.REFUNDED]: "Refunded",
    [SELLER_PACKAGE_ORDER_STATUS.FULFILLED]: "Fulfilled",
    [SELLER_PACKAGE_ORDER_STATUS.PARTIALLY_FULFILLED]: "Partially Fulfilled"
};

export const SELLER_PACKAGE_BENEFIT_CARD_SOURCES = {
    DIY: "DIY",
    A2I: "A2I",
    ORDER_SUMMARY: "ORDER_SUMMARY"
};

export const SELLER_PACKAGE_VERSION = {
    V1: "V1",
    V2: "V2"
};

export const getSellerPackageCmsSlug = (type) => {
    let slug = "";
    if (type === PACKAGE_TYPES_MAP_V2.FREE) {
        slug = "a2i-seller-package-sell-card";
    } else if (type === PACKAGE_TYPES_MAP_V2.SELL_PRO) {
        slug = "seller-package-sold-pro-widget";
    } else if (type === PACKAGE_TYPES_MAP_V2.SELL_LITE) {
        slug = "seller-package-sold-lite-widget";
    }

    return slug;

};

export const SELLER_PACKAGE_EVENT_NAMES = {
    A2I_FREE_STRIP_CLICKED: "view_addon_strip_clicked",
    ORDER_SUMMARY_MANAGE_APPOINTMENT_CLICKED: "order_summary_manage_appt",
    PRODUCT_PAGE_PACKAGE_SELECTED: "landing_page_package_selected",
    KNOW_BENEFITS_CROSS_CLICKED: "know_benefits_cross_clicked",
    DIY_FREE_CARD_CLICKED: "view_addon_card_clicked",
    DIY_CAR_INSPECTION_STRIP_CLICKED: "car_insp_tab_addon_strip_clicked",
    DIY_FREE_STRIP_CLICKED: "view_addon_strip_clicked",
    PRODUCT_PAGE_CROSS_CLICKED: "sp_landing_page_cross_clicked",
    SELLER_PACKAGE_VIEWED: "sp_viewed"
};
